import Page from "../../../Components/Page";

export default function NextEventPage() {
    return (
        <Page>
            <h1>Test</h1>
        </Page>
    )
}